import {
    GET_GRADIENTS,
    CREATE_GRADIENT,
    UPDATE_GRADIENT,
    DELETE_GRADIENT,
    SET_GRADIENT,
    REMOVE_GRADIENT,
    DOWNLOAD_GRADIENT,
  } from "../constants/types";
  import axios from "axios";

  const url = process.env.REACT_APP_API_URL;

  export const getGradients = () => async dispatch => {
    const result = await axios.get(`${url}/gradients`);
    dispatch({
        type: GET_GRADIENTS,
        payload: result.data
    })
  }


  export const downloadGradient = (gradientName) => async(dispatch) => {
      window.open(`${url}/gradients/download/${gradientName}`);
      dispatch({
          type: DOWNLOAD_GRADIENT,
          payload: gradientName,
      })
  }

export const setGradient = (gradient) => ({
    type: SET_GRADIENT,
    payload: gradient
})

export const removeGradient = () => ({
    type: REMOVE_GRADIENT,
    payload: null,
})

export const createGradient = (gradient) => async (dispatch) => {
    const result = await axios.post(`${url}/gradients`,gradient);

    dispatch({
        type: CREATE_GRADIENT,
        payload: result.data,
    });
};

export const deleteGradient = (id) => async (dispatch) =>{
    await axios.delete(`${url}/gradients/${id}`);

    dispatch({
        type: DELETE_GRADIENT,
        payload: id,
    });
};

export const updateGradient = gradient => async (dispatch) => {
    const result = await axios.put(`${url}/gradients/${gradient._id}`,gradient);

    dispatch({
        type: UPDATE_GRADIENT,
        payload: result.data,
    });
};

